
(function(){
  const THRESHOLD = 5000; // cents = €50
  const BAR_ID = 'free-ship-bar';
  function fmt(c){return '€'+(c/100).toFixed(2).replace('.',',');}
  function ensureBar(){
    let b=document.getElementById(BAR_ID);
    if(b) return b;
    b=document.createElement('div');
    b.id=BAR_ID;
    b.style.cssText='position:sticky;top:0;z-index:9999;background:linear-gradient(90deg,#7c5cff,#22d3ee);color:#fff;text-align:center;padding:10px 16px;font:600 13px -apple-system,Inter,sans-serif;letter-spacing:.3px;box-shadow:0 2px 12px rgba(0,0,0,.15)';
    document.body.insertBefore(b,document.body.firstChild);
    return b;
  }
  function render(total){
    const bar=ensureBar();
    if(total >= THRESHOLD){
      bar.innerHTML='🎉 You unlocked FREE SHIPPING on your order!';
      bar.style.background='linear-gradient(90deg,#22c55e,#16a34a)';
    }else{
      const left=THRESHOLD-total;
      const pct=Math.round(total/THRESHOLD*100);
      bar.innerHTML=`🚚 Add <strong>${fmt(left)}</strong> more for <strong>FREE SHIPPING</strong> &nbsp;·&nbsp; <span style="display:inline-block;width:120px;height:6px;background:rgba(255,255,255,.3);border-radius:3px;vertical-align:middle;margin-left:8px"><span style="display:block;width:${pct}%;height:100%;background:#fff;border-radius:3px;transition:width .4s"></span></span>`;
    }
    // Product page inline
    document.querySelectorAll('[data-free-ship-inline]').forEach(el=>{
      if(total>=THRESHOLD){el.innerHTML='✅ You qualify for FREE SHIPPING';}
      else{el.innerHTML=`Add <strong>${fmt(THRESHOLD-total)}</strong> more and get <strong>FREE SHIPPING</strong>`;}
    });
  }
  function fetchCart(){
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(r=>r.json()).then(c=>render(c.total_price||0))
      .catch(()=>render(0));
  }
  // initial + on ajax cart updates
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fetchCart);
  else fetchCart();
  // Shopify themes fire these events
  ['cart:updated','cart:refresh','variant:change','product:added-to-cart'].forEach(e=>document.addEventListener(e,fetchCart));
  // Intercept XHR/fetch cart mutations
  const origFetch=window.fetch;
  window.fetch=function(){
    const p=origFetch.apply(this,arguments);
    const u=arguments[0];
    if(typeof u==='string' && /\/cart\/(add|change|update|clear)/.test(u)){
      p.then(()=>setTimeout(fetchCart,200));
    }
    return p;
  };
})();
